<template>
  <div>
    <div :class="{ show: show }" class="modal fade" id="snomed-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document" style="max-width: 650px;">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-size wysiwyg">
            <div class="modal-header">
              <div>
                <button type="button" class=" btn btn--close btn--icon-only" @click="$emit('closeModal')">
                  <svg class="svg-icon svg-close" aria-hidden="true" focusable="false">
                    <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#close"></use>
                  </svg>
                </button>
              </div>
            </div>
            <SnomedBrowserLicenceComponent :popinSnomedBrowserLicence="popinSnomedBrowserLicence"
              @refreshPage="refreshPage"></SnomedBrowserLicenceComponent>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'show modal-backdrop fade': show }" @click="$emit('closeModal')"></div>
  </div>

</template>

<script>
import SnomedBrowserLicenceComponent from "./SnomedBrowserLicenceComponent";
import ConceptsStore from "../../concepts-store";
export default {
  name: "SnomedBrowserLicence",
  components: {
    SnomedBrowserLicenceComponent
  },
  props: {
    show: Boolean,
    popinSnomedBrowserLicence: Boolean
  },

  data() {
    return {
      store: ConceptsStore.state,
      licenceText: "",
      hasError: false,
    };

  },

  methods: {
    refreshPage() {
      // Recharger la page parente avec la licence Browser enregistrée
      this.$parent.forceRerender();
    }
  }
}
</script>
<style scoped>
.redTheme {
  color: #D20024 !important;
  /* couleur erreur dans la charte graphique */
  /* Imporant to override the default behaviour */
}

.isUserConnectedClass {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 2.5rem !important;
  border-bottom-right-radius: 2.5rem !important;
  border-top-right-radius: 2.5rem !important;
  /* Harmoniser le graphisme des bouton dans le cas où il y en a 3 */
}
</style>
